export const staticShopSettings = {
  colorOptionNames: ['color', 'kleur', 'kleuren', 'colors', 'colour', 'farbe', 'couleur'],
};
